import styled from "styled-components";

export const Slider = styled.div`
  padding-bottom: ${({ theme }) => theme.rem(32)};
`